import { BoundDatePicker } from "lib/@components/datePicker"

/**
 * Recipient input for a `date` requested field. Date picker bound to `values.<field.id>`.
 *
 * @param {object} props
 * @param {{ id: string }} props.field
 */
export function DateFieldInput({ field }) {
    return <BoundDatePicker field={`values.${field.id}`} noLabel />
}
